
export enum StatusEvent
{
    CameraConnected = "CameraConnected",
    CameraDisconnected = "CameraDisconnected",
    PictureReceived = "PictureReceived",
    CameraHalted = "CameraHalted",
    InputActive = "InputActive",
    ServerDisconnected = "ServerDisconnected",
    ServerConnected = "ServerConnected",
    InputInactive = "InputInactive",
    Launching = "Launching",
    Unauthorized = "Unauthorized",
    AlreadyLoggedIn = "AlreadyLoggedIn",
    Malfunction = "Malfunction"
}
